import React, { useState, useRef, useLayoutEffect } from "react";
import { CircularProgress, Box } from "@mui/material";
import { THUMB_H, THUMB_W } from "../../../../utils/const";
import SpecimenBBox from "./SpecimenBBox";

const useElementSizeById = (elementId) => {
    const [size, setSize] = useState({ width: 0, height: 0 });

    useLayoutEffect(() => {
        const element = document.getElementById(elementId);
        if (!element) {
            console.warn(`Element with ID "${elementId}" not found for ResizeObserver.`);
            return;
        }
        const observer = new ResizeObserver(entries => {
            if (entries[0]) {
                setSize({
                    width: entries[0].contentRect.width,
                    height: entries[0].contentRect.height,
                });
            }
        });
        observer.observe(element);
        setSize({
            width: element.offsetWidth,
            height: element.offsetHeight,
        });

        return () => {
            observer.disconnect();
        };
    }, [elementId]); // Re-run effect if the elementId prop changes

    return size;
};


const TrayImageContainer = ({
    specimens,
    specimenOnDisplay,
    trayImage,
    handleSpecimenJump,
}) => {
    const [imageHeightFactor, setImageHeightFactor] = useState(0.5);
    const [imageWidthFactor, setImageWidthFactor] = useState(0.5);
    const containerRef = useRef();
    const trayInputsSize = useElementSizeById("tray-inputs");
    const trayContainerSize = useElementSizeById("tray-header");

    useLayoutEffect(() => {
        let offsetHeight = trayContainerSize.height - trayInputsSize.height - 70
        let offsetWidth = containerRef.current.offsetWidth

        let calculatedScaleFactor = 0.5
        Math.min(offsetWidth / 640, offsetHeight / 480)

        calculatedScaleFactor = Math.min(offsetWidth / 640, offsetHeight / 480)
        setImageHeightFactor(calculatedScaleFactor);
        setImageWidthFactor(calculatedScaleFactor);

    }, [trayInputsSize.width, trayInputsSize.height,
    trayContainerSize.width, trayContainerSize.height])

    return (
        <div
            className={"flex relative flex-1"}
            id={"tray-image"}
            style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "1rem",
                marginLeft: "0",
                width: '100%',
                maxHeight: "100%"
            }}
            ref={containerRef}
        >
            <Box
                style={{
                    height: `${THUMB_H * imageHeightFactor}px`,
                    width: `${THUMB_W * imageWidthFactor}px`,
                }}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                }}
            >
                {!trayImage ? (
                    <CircularProgress size={"5rem"} id={"loading-tray"} />
                ) : (
                    <img
                        src={trayImage}
                        width={imageWidthFactor * THUMB_W}
                        height={imageHeightFactor * THUMB_H}
                        alt={"tray"}
                        data-testid="tray-image"
                        style={{ width: '100%' }}

                    />
                )}
                {specimens &&
                    /*eslint array-callback-return: ["error", { allowImplicit: true }]*/
                    specimens.map((s, i) => {
                        if (Array.isArray(s?.bbox)) {
                            const h = `${[s.bbox[3] - s.bbox[1]] *
                                (imageHeightFactor * 0.95)
                                }px`;
                            const w = `${(s.bbox[2] - s.bbox[0]) * imageWidthFactor
                                }px`;
                            const topX = `${[
                                [s.bbox[0]] * imageWidthFactor,
                            ]}px`;
                            let topY;
                            if (i >= 0 && i <= 3) {
                                topY = `${[imageHeightFactor] * 20}px`;
                            } else {
                                topY = `${s.bbox[1] * imageHeightFactor * 1.03
                                    }px`;
                            }
                            const border =
                                i === specimenOnDisplay
                                    ? "3px solid #428BCA"
                                    : "0px solid #428BCA";
                            return (
                                <SpecimenBBox
                                    key={`specimen-${i}`}
                                    s={s}
                                    i={i}
                                    w={w}
                                    h={h}
                                    topX={topX}
                                    topY={topY}
                                    border={border}
                                    handleJump={() => handleSpecimenJump(i)}
                                ></SpecimenBBox>
                            );
                        }
                        return;
                    })}
            </Box>
        </div>
    );
};

export default TrayImageContainer;
